document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".video-testimonials-swiper", {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: true,
    initialSlide: 1,
    loop: true,
    loopedSlides: 3,
    breakpoints: {
      768: {
        spaceBetween: 20,
        centeredSlides: false,
        initialSlide: 1,
        slidesPerView: 3,
      },
    },
  });

  const openButtons = document.querySelectorAll(".open-modal");
  const modal = document.getElementById("video-testimonials-modal");
  const videoWrappers = document.querySelectorAll(".video-wrapper");
  const closeModal = document.querySelector(".close-modal");
  const body = document.querySelector("body");
  
  openButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const index = this.getAttribute("data-index");
  
      videoWrappers.forEach((wrapper, i) => {
        const video = wrapper.querySelector(".modal-video");
        wrapper.classList.remove("active"); 
        if (video.src) {
          video.pause();
          video.currentTime = 0;
        }
      });
  
      const selectedWrapper = videoWrappers[index];
      if (selectedWrapper) {
        selectedWrapper.classList.add("active");
        const videoElement = selectedWrapper.querySelector(".modal-video");
        
        if (!videoElement.src && videoElement.dataset.src) {
          videoElement.src = videoElement.dataset.src;
          videoElement.load();
        }
        
        videoElement.play();
      }
      
      body.classList.add('overflow-hidden');
      modal.classList.add("show");
    });
  });
  
  
  function closeVideoModal() {
    modal.classList.remove("show");
  
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector(".modal-video");
      if (video.src) {
        video.pause();
        video.currentTime = 0;
      }
    });

    body.classList.remove('overflow-hidden');
  }
  
  closeModal.addEventListener("click", closeVideoModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeVideoModal();
    }
  });
  
});
